module.exports = __webpack_public_path__ + "img/icon-diccionary-2.8fb3a4cd.svg";